import { FC } from "react";

import {
  IRichLogData,
  IRichViewLogsProps,
  TDrawerCloseFunction,
} from "@ryde/shared";

import { RichLogsHeader } from "../../rich-logs-components";
import { useProductionViewLogs } from "../hooks";

interface IProductionLogsHeader extends IRichViewLogsProps {
  logDataComputed?: IRichLogData;
  onCloseDrawer: TDrawerCloseFunction;
}

export const ProductionLogsHeader: FC<IProductionLogsHeader> = ({
  logDataComputed,
  logsFromWatchedApiOld,
  onCloseDrawer,
}) => {
  const { isFinished } = useProductionViewLogs();

  return (
    <RichLogsHeader
      onCloseDrawer={onCloseDrawer}
      entity="rideProduction"
      isFinished={isFinished}
      logsFormWatched={logDataComputed}
      logsFromWatchedApiOld={logsFromWatchedApiOld}
    />
  );
};
